// CE QUE LE CLAVIER (OU LE COLLAGE) ÉCRIT À NOTRE PLACE — miroir EXACT du
// module mobile src/features/lesson/saisie-code.ts (reps-app), vérifié par le
// harnais saisie-code-parity.test.ts côté mobile : toute évolution se fait
// DANS LES DEUX, dans le même ordre.
//
// Sur Safari iOS, la « Ponctuation intelligente » du clavier (activée par
// défaut) s'applique aussi au textarea caché de Monaco : mesuré au clavier
// logiciel FR du simulateur (26 août 2026), la touche guillemet insère des
// chevrons \u00ab \u00bb AVEC leur espace insécable, et la touche apostrophe
// insère \u2019 ; un clavier EN insère les courbes \u201c \u201d. Sur
// desktop, le même poison arrive par COLLAGE : un code copié depuis un PDF ou
// une page « embellie » porte guillemets courbes, insécables et accents
// décomposés (NFD). Dans un éditeur de code, la substitution est invisible à
// l'œil et fatale : SyntaxError sur un code que l'apprenant voit juste.
//
// On ramène chaque substitut à son caractère de programmeur. Aucune de ces
// graphies n'apparaît dans le corpus (starter, solution et code affiché des
// 481 leçons : vérifié), il n'y a donc rien à perdre. NFC en prime : un accent
// combinant s'affiche comme le précomposé mais la correction, qui compare des
// chaînes, dirait faux.
//
// Les caractères sont écrits en échappements \u et jamais en clair, comme
// dans normalizeText (grade.js) : un blanc exotique en clair est invisible à
// la relecture.
export function normaliserSaisieCode(texte) {
    return (
        String(texte == null ? "" : texte)
            .normalize("NFC")
            // Apostrophes et guillemets courbes -> droits. Le backtick est
            // LAISSÉ tel quel : c'est un vrai caractère de code (gabarits
            // JavaScript).
            .replace(/[\u2018\u2019\u201a\u201b\u2032\u02bc]/g, "'")
            .replace(/[\u201c\u201d\u201e\u201f\u2033]/g, '"')
            // Guillemets français du clavier FR : iOS insère le chevron ET son
            // espace insécable d'un seul appui sur la touche guillemet — on
            // absorbe la paire entière, sinon la chaîne garderait une espace
            // parasite (print(" test ") au lieu de print("test")).
            .replace(/\u00ab[\u00a0\u202f]?/g, '"')
            .replace(/[\u00a0\u202f]?\u00bb/g, '"')
            .replace(/[\u2039\u203a]/g, "'")
            // Le cadratin est ce que le clavier met à la place de DEUX
            // tirets tapés : il en redonne deux. Ramené à un seul, il cassait
            // le commentaire SQL (`-- note` devenait `- note`) et le `i--` de
            // JavaScript (décision du 17/10/2026).
            .replace(/\u2014/g, "--")
            // Les autres tirets typographiques et le moins mathématique.
            .replace(/[\u2010-\u2013\u2015\u2212]/g, "-")
            // Points de suspension : trois points, comme ils ont été tapés.
            .replace(/\u2026/g, "...")
            // Blancs exotiques : invisibles à l'œil, et Python les refuse
            // jusque dans l'indentation (invalid non-printable character
            // U+00A0).
            .replace(/[\u0085\u00a0\u1680\u2000-\u200a\u202f\u205f\u3000]/g, " ")
            // Largeur nulle : rien à voir à l'écran, un caractère de plus pour
            // le tokenizer Python.
            .replace(/[\u200b-\u200d\ufeff]/g, "")
    );
}
